import About from "../components/About";

const AboutInterface = () => {
  return (
    <>
      <About />
    </>
  );
};
export default AboutInterface;
